import { Tel } from "#app/_ui/components/media/Tel";
import { hoursOnlineSupport, telOnlineSupport } from "#app/lib/company";
import { toUsaTelHref } from "#app/lib/telephone";
import { Alert, AlertContent, AlertTitle } from "#ui/alert";
import { Card, CardContent } from "#ui/card";
import { Icon } from "#ui/icon";
import { Link, LinkButton } from "#ui/link";
import { H1, P } from "#ui/typography";

export function ForgotPasswordSuccess() {
  return (
    <div className="grid w-full max-w-800px gap-30px">
      <Card variant="white-border-and-blur">
        <CardContent>
          <div className="flex flex-col items-center gap-15px text-center">
            <Icon
              name="baird-checkmark-circle"
              size="baird-lg"
              palette="success"
              className="mb-5px"
            />
            <H1 size="h5" className="leading-none">
              Check your email
            </H1>
            <P
              size="sm"
              palette="neutral-subtle"
              className="mb-5px text-balance"
            >
              An email confirmation has been sent to the email address
              associated with your account. Click the verification link in the
              email in order to continue.
            </P>
            <LinkButton href="/sign-in">Continue to sign in</LinkButton>
          </div>
        </CardContent>
      </Card>

      <Alert intent="warning">
        <AlertContent>
          <AlertTitle>
            If you do not receive an email, please contact{" "}
            <Link href="/tech-support" underline>
              Online Support
            </Link>{" "}
            or{" "}
            <Tel href={telOnlineSupport} hrefFn={toUsaTelHref}>
              {telOnlineSupport}
            </Tel>
            , {hoursOnlineSupport}.
          </AlertTitle>
        </AlertContent>
      </Alert>
    </div>
  );
}
